<template>
  <div class="chapter-footer">
    <div
      class="chapter-square-footer shrink-on-active"
      @click="changePage('settings')"
    >
      <inline-svg
        class="svg-footer"
        :src="
          page == 'settings'
            ? require('../../assets/svg/AccountOn.svg').default
            : require('../../assets/svg/AccountOff.svg').default
        "
      ></inline-svg>
      <p :class="{ chaptersquarefooterselected: page == 'settings' }">
        {{ $t("chapter.chapter-footer.user") }}
      </p>
    </div>
    <!-- REMOVED FOR NOW TO GET AN ODD NUMBER MENU -->
    <!-- <div
      class="chapter-square-footer shrink-on-active"
      @click="changePage('videos')"
    >
      <inline-svg
        class="svg-footer"
        :src="
          page == 'videos'
            ? require('../../assets/svg/LessonsOn.svg').default
            : require('../../assets/svg/LessonOff.svg').default
        "
      ></inline-svg>
      <p :class="{ chaptersquarefooterselected: page == 'videos' }">
        {{ $t("chapter.chapter-footer.lessons") }}
      </p>
    </div> -->
    <div
      class="chapter-square-footer shrink-on-active"
      @click="changePage('dictionary')"
    >
      <inline-svg
        class="svg-footer"
        :class="{ svgfooterselected: page == 'dictionary' }"
        :src="
          page == 'dictionary'
            ? require('../../assets/svg/DictionaryOn.svg').default
            : require('../../assets/svg/DictionaryOff.svg').default
        "
      ></inline-svg>
      <p :class="{ chaptersquarefooterselected: page == 'dictionary' }">
        {{ $t("chapter.chapter-footer.dict") }}
      </p>
    </div>
    <div class="chapter-square-footer shrink-on-active" @click="goToCourse">
      <inline-svg
        class="svg-footer"
        :class="{ svgfooterselected: page == 'main' }"
        :src="
          page == 'main'
            ? require('../../assets/svg/CourseOn.svg').default
            : require('../../assets/svg/CourseOff.svg').default
        "
      ></inline-svg>
      <p :class="{ chaptersquarefooterselected: page == 'main' }">
        {{ $t("chapter.chapter-footer.curse") }}
      </p>
    </div>
  </div>
</template>

<script>
import "./chapter-footer.scss";
export default {
  name: "chapter-footer",
  props: ["changePage", "page", "nextLesson"],
  data() {
    return {};
  },
  created() {},
  methods: {
    goToCourse() {
      console.log(this.nextLesson);
      if (this.$route.name != "chapter") {
        this.$router.push({
          path: `/chapter/`
        });
      }
      this.changePage("main");
    },
    navigate(path) {
      this.$router.push(`/${path}`);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// chapter-footer.vue?7b8066b2